module.exports = {"360732100":"潋江镇","360732101":"江背镇","360732102":"古龙冈镇","360732103":"梅窖镇","360732104":"高兴镇","360732105":"良村镇","360732106":"龙口镇","360732200":"兴江乡","360732201":"樟木乡","360732202":"东村乡","360732203":"兴莲乡","360732204":"杰村乡","360732205":"社富乡","360732206":"埠头乡","360732207":"永丰乡","360732208":"隆坪乡","360732209":"均村乡","360732210":"茶园乡","360732211":"崇贤乡","360732212":"枫边乡","360732213":"南坑乡","360732214":"城岗乡","360732215":"方太乡","360732216":"鼎龙乡","360732217":"长冈乡","360732400":"兴国县工业园"}


//////////////////
// WEBPACK FOOTER
// ./src/town/360732.json
// module id = 1199
// module chunks = 0